// This file is part of re-motion
// Copyright (c) rubicon IT GmbH, www.rubicon.eu
// 

/**
 * Custom base class for errors.
 */
export class CustomError
{
  readonly message: string;
  readonly name: string;
  readonly stack?: string;

  constructor(message: string, name: string)
  {
    this.message = message;
    this.name = name;
    this.stack = (new Error()).stack;
  }
}